import { render, staticRenderFns } from "./step_budget_epidemiological_control.vue?vue&type=template&id=6a05bba0&scoped=true"
import script from "./step_budget_epidemiological_control.vue?vue&type=script&lang=js"
export * from "./step_budget_epidemiological_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05bba0",
  null
  
)

export default component.exports